import InfoIcon from '@mui/icons-material/Info';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FC } from 'react';
import Hints from './Hints';
import InfoTooltip from '@components/search/InfoTooltip';

interface InfoIconWithHintsProps {
    close?: () => void;
    hints?: string[];
    isOpen?: boolean;
    open?: () => void;
}

const InfoIconWithHints: FC<InfoIconWithHintsProps> = ({ close, hints = [], isOpen, open }) => {
    if (!hints.length) {
        return <InfoIcon sx={{ alignSelf: 'center', mx: 1 }} />;
    }

    return (
        <InfoTooltip
            onClose={close}
            onOpen={open}
            open={isOpen}
            placement="top-start"
            sx={{ maxHeight: '15px' }}
            title={<Hints hints={hints} />}
            disableFocusListener
        >
            <InfoOutlinedIcon sx={{ alignSelf: 'center', color: 'grey.400', mr: 1 }} />
        </InfoTooltip>
    );
};

export default InfoIconWithHints;
